import React, { useState, useEffect, useMemo } from "react";

import { Link } from "react-router-dom";
import FAQ from "../../component/fap/fap";
import Layout from "../../component/layout/layout";

const FAQPage = () => {
    return (
        <>
            <Layout>
                <FAQ />
            </Layout>
        </>
    );
};
export default FAQPage;
